/**
 * Swagger Interface
 * 数据交换格式: JSON
 *
 * OpenAPI spec version: v2.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import ajax, { AjaxPromise, ExtraFetchParams } from '@ajax';
import * as models from '../model/models';

/* tslint:disable:no-unused-variable member-ordering object-literal-shorthand */

/**
 * @description userAnswerUsingGet参数
 * @property `pageNum` 页码
 * @property `pageSize` 每页数量
 * @property `targetUser` 查看的用户
 */
export interface ParamsuserAnswerUsingGet {
  // queryParams
  /**
   * 页码
   */
  pageNum: number;
  /**
   * 每页数量
   */
  pageSize: number;
  /**
   * 查看的用户
   */
  targetUser: string;
}
/**
 * @description userArticleHotUsingGet参数
 * @property `pageNum` 页码
 * @property `pageSize` 每页数量
 * @property `targetUser` 查看的用户
 */
export interface ParamsuserArticleHotUsingGet {
  // queryParams
  /**
   * 页码
   */
  pageNum: number;
  /**
   * 每页数量
   */
  pageSize: number;
  /**
   * 查看的用户
   */
  targetUser: string;
}
/**
 * @description userArticleNewUsingGet参数
 * @property `pageNum` 页码
 * @property `pageSize` 每页数量
 * @property `targetUser` 查看的用户
 * @property `type` 查看类型:DRAFT-草稿,PUBLISHED-已发布
 */
export interface ParamsuserArticleNewUsingGet {
  // queryParams
  /**
   * 页码
   */
  pageNum: number;
  /**
   * 每页数量
   */
  pageSize: number;
  /**
   * 查看的用户
   */
  targetUser: string;
  /**
   * 查看类型:DRAFT-草稿,PUBLISHED-已发布
   */
  type: string;
}
/**
 * @description userArticlePageNewUsingGet参数
 * @property `pageNum` 页码
 * @property `pageSize` 每页数量
 * @property `[status]` 目标文章状态
 * @property `targetUser` 查看的用户
 */
export interface ParamsuserArticlePageNewUsingGet {
  // queryParams
  /**
   * 页码
   */
  pageNum: number;
  /**
   * 每页数量
   */
  pageSize: number;
  /**
   * 目标文章状态
   */
  status?: string;
  /**
   * 查看的用户
   */
  targetUser: string;
}
/**
 * @description userArticleUsingGet参数
 * @property `pageNum` 页码
 * @property `pageSize` 每页数量
 * @property `targetUser` 被查看人姓名id
 * @property `type` 查看类型:1-草稿,2-已发布
 */
export interface ParamsuserArticleUsingGet {
  // queryParams
  /**
   * 页码
   */
  pageNum: number;
  /**
   * 每页数量
   */
  pageSize: number;
  /**
   * 被查看人姓名id
   */
  targetUser: string;
  /**
   * 查看类型:1-草稿,2-已发布
   */
  type: number;
}
/**
 * @description userByTypesMessageUsingPost参数
 * @property `pageNum` 页码
 * @property `pageSize` 每页数量
 */
export interface ParamsuserByTypesMessageUsingPost {
  // queryParams
  /**
   * 页码
   */
  pageNum: number;
  /**
   * 每页数量
   */
  pageSize: number;
}
/**
 * 查询类型,数组为空则全部/1赞/2评论/3回复/4@/5邀请/6关注/7回答/8留言/9圈子加入申请
 */
export type ParamsBodyuserByTypesMessageUsingPost = Array<number>;
/**
 * @description userCollectionArticleIdCancelUsingPost参数
 * @property `articleId` articleId
 */
export interface ParamsuserCollectionArticleIdCancelUsingPost {
  // pathParams
  /**
   * articleId
   */
  articleId: number;
}
/**
 * @description userCollectionArticleIdUsingPost参数
 * @property `articleId` articleId
 */
export interface ParamsuserCollectionArticleIdUsingPost {
  // pathParams
  /**
   * articleId
   */
  articleId: number;
}
/**
 * @description userCollectionUsingGet参数
 * @property `lastMark` 上页的最后一条
 * @property `pageSize` 每页数量
 */
export interface ParamsuserCollectionUsingGet {
  // queryParams
  /**
   * 上页的最后一条
   */
  lastMark: number;
  /**
   * 每页数量
   */
  pageSize: number;
}
/**
 * @description userCommentUsingGet参数
 * @property `pageNum` 页码
 * @property `pageSize` 每页数量
 * @property `targetUser` 查看的用户
 */
export interface ParamsuserCommentUsingGet {
  // queryParams
  /**
   * 页码
   */
  pageNum: number;
  /**
   * 每页数量
   */
  pageSize: number;
  /**
   * 查看的用户
   */
  targetUser: string;
}
/**
 * @description userDetailsUsingGet参数
 * @property `targetUser` 被查看用户
 */
export interface ParamsuserDetailsUsingGet {
  // queryParams
  /**
   * 被查看用户
   */
  targetUser: string;
}
/**
 * 用户信息
 */
export type ParamsBodyuserEditUsingPost = models.UserInfoCondition;
/**
 * 想要关注/取关的用户
 */
export type ParamsBodyuserFollowUsingPost = models.UserCondition;
/**
 * @description userInformationUsingGet参数
 * @property `targetUser` 查看的用户
 */
export interface ParamsuserInformationUsingGet {
  // queryParams
  /**
   * 查看的用户
   */
  targetUser: string;
}
/**
 * @description userMessageIdUsingDelete参数
 * @property `messageId` 消息id
 */
export interface ParamsuserMessageIdUsingDelete {
  // pathParams
  /**
   * 消息id
   */
  messageId: number;
}
/**
 * @description userMessageNumberUsingPost参数
 * @property `[read]` 是否已读，false未读/true已读 不传就是全部
 */
export interface ParamsuserMessageNumberUsingPost {
  // queryParams
  /**
   * 是否已读，false未读/true已读 不传就是全部
   */
  read?: boolean;
}
/**
 * 查询类型,0全部/1赞/2评论/3回复/4@/5邀请/6关注/7回答/8留言/9圈子加入申请
 */
export type ParamsBodyuserMessageNumberUsingPost = Array<number>;
/**
 * @description userMessageUsingGet参数
 * @property `pageNum` 页码
 * @property `pageSize` 每页数量
 * @property `type` 查询类型,0全部/1赞/2评论/3回复/4@/5邀请/6关注/7回答/8留言/9圈子/10打赏
 */
export interface ParamsuserMessageUsingGet {
  // queryParams
  /**
   * 页码
   */
  pageNum: number;
  /**
   * 每页数量
   */
  pageSize: number;
  /**
   * 查询类型,0全部/1赞/2评论/3回复/4@/5邀请/6关注/7回答/8留言/9圈子/10打赏
   */
  type: number;
}
/**
 * @description userMyCollectionUsingGet参数
 * @property `pageNum` 页码
 * @property `pageSize` 每页数量
 */
export interface ParamsuserMyCollectionUsingGet {
  // queryParams
  /**
   * 页码
   */
  pageNum: number;
  /**
   * 每页数量
   */
  pageSize: number;
}
/**
 * @description userMyFollowUsingGet参数
 * @property `pageNum` 页码
 * @property `pageSize` 每页数量
 * @property `type` 查看类型1-关注,2-粉丝
 */
export interface ParamsuserMyFollowUsingGet {
  // queryParams
  /**
   * 页码
   */
  pageNum: number;
  /**
   * 每页数量
   */
  pageSize: number;
  /**
   * 查看类型1-关注,2-粉丝
   */
  type: number;
}
/**
 * pressVO
 */
export type ParamsBodyuserPressUsingPost = models.PressVO;
/**
 * @description userQuestionUsingGet参数
 * @property `pageNum` 页码
 * @property `pageSize` 每页数量
 * @property `targetUser` 查看的用户
 */
export interface ParamsuserQuestionUsingGet {
  // queryParams
  /**
   * 页码
   */
  pageNum: number;
  /**
   * 每页数量
   */
  pageSize: number;
  /**
   * 查看的用户
   */
  targetUser: string;
}
/**
 * @description userSimpleUsingGet参数
 * @property `targetUser` 被查看用户
 */
export interface ParamsuserSimpleUsingGet {
  // queryParams
  /**
   * 被查看用户
   */
  targetUser: string;
}
/**
 * @description userStickyMessageIdUsingPut参数
 * @property `messageId` 消息id
 * @property `sticky` 是否置顶 1置顶/0取消置顶
 */
export interface ParamsuserStickyMessageIdUsingPut {
  // pathParams
  /**
   * 消息id
   */
  messageId: number;
  // queryParams
  /**
   * 是否置顶 1置顶/0取消置顶
   */
  sticky: number;
}
/**
 * @description userTaggingUsingGet参数
 * @property `pageNum` 页码
 * @property `pageSize` 每页数量
 * @property `targetUser` 查看的用户
 */
export interface ParamsuserTaggingUsingGet {
  // queryParams
  /**
   * 页码
   */
  pageNum: number;
  /**
   * 每页数量
   */
  pageSize: number;
  /**
   * 查看的用户
   */
  targetUser: string;
}
/**
 * @description userThumpUpUsingGet参数
 * @property `pageNum` 页码
 * @property `pageSize` 每页数量
 * @property `targetUser` 查看的用户
 */
export interface ParamsuserThumpUpUsingGet {
  // queryParams
  /**
   * 页码
   */
  pageNum: number;
  /**
   * 每页数量
   */
  pageSize: number;
  /**
   * 查看的用户
   */
  targetUser: string;
}
/**
 * @description userVoteUsingGet参数
 * @property `pageNum` 页码
 * @property `pageSize` 每页数量
 * @property `targetUser` 查看的用户
 */
export interface ParamsuserVoteUsingGet {
  // queryParams
  /**
   * 页码
   */
  pageNum: number;
  /**
   * 每页数量
   */
  pageSize: number;
  /**
   * 查看的用户
   */
  targetUser: string;
}
export class UserApi {
  protected $basePath = '/community/be'.replace(/\/$/, '');

  public constructor(basePath?: string) {
    if (basePath !== undefined) {
      this.$basePath = basePath.replace(/\/$/, '');
    }
  }

  /**
   * 
   * @summary 用户页面--回答
   * @param params ParamsuserAnswerUsingGet
   
   * @param opt ajax config
   * @returns models.CommonResultPageableResultAnswerSimpleInfo
   */
  public userAnswerUsingGet = (
    params: ParamsuserAnswerUsingGet,
    opt?: ExtraFetchParams
  ): AjaxPromise<models.CommonResultPageableResultAnswerSimpleInfo> => {
    const path = '/api/user/answer';
    const url = this.$basePath + path;
    const p: any = {};
    p.query = {};
    if ('pageNum' in params) p.query.pageNum = params.pageNum;
    ajax.check(params.pageNum, 'pageNum');
    if ('pageSize' in params) p.query.pageSize = params.pageSize;
    ajax.check(params.pageSize, 'pageSize');
    if ('targetUser' in params) p.query.targetUser = params.targetUser;
    ajax.check(params.targetUser, 'targetUser');
    return ajax.ajax(
      {
        ...opt,
        method: 'GET',
        url,
        ...p
      },
      path,
      this.$basePath
    );
  };
  /**
   * 
   * @summary 用户页面--文章--热门
   * @param params ParamsuserArticleHotUsingGet
   
   * @param opt ajax config
   * @returns models.CommonResultPageableResultSingleArticleInfo
   */
  public userArticleHotUsingGet = (
    params: ParamsuserArticleHotUsingGet,
    opt?: ExtraFetchParams
  ): AjaxPromise<models.CommonResultPageableResultSingleArticleInfo> => {
    const path = '/api/user/article/hot';
    const url = this.$basePath + path;
    const p: any = {};
    p.query = {};
    if ('pageNum' in params) p.query.pageNum = params.pageNum;
    ajax.check(params.pageNum, 'pageNum');
    if ('pageSize' in params) p.query.pageSize = params.pageSize;
    ajax.check(params.pageSize, 'pageSize');
    if ('targetUser' in params) p.query.targetUser = params.targetUser;
    ajax.check(params.targetUser, 'targetUser');
    return ajax.ajax(
      {
        ...opt,
        method: 'GET',
        url,
        ...p
      },
      path,
      this.$basePath
    );
  };
  /**
   * 
   * @summary 用户页面--文章--最新
   * @param params ParamsuserArticleNewUsingGet
   
   * @param opt ajax config
   * @returns models.CommonResultPageableResultSingleArticleInfo
   */
  public userArticleNewUsingGet = (
    params: ParamsuserArticleNewUsingGet,
    opt?: ExtraFetchParams
  ): AjaxPromise<models.CommonResultPageableResultSingleArticleInfo> => {
    const path = '/api/user/article/new';
    const url = this.$basePath + path;
    const p: any = {};
    p.query = {};
    if ('pageNum' in params) p.query.pageNum = params.pageNum;
    ajax.check(params.pageNum, 'pageNum');
    if ('pageSize' in params) p.query.pageSize = params.pageSize;
    ajax.check(params.pageSize, 'pageSize');
    if ('targetUser' in params) p.query.targetUser = params.targetUser;
    ajax.check(params.targetUser, 'targetUser');
    if ('type' in params) p.query.type = params.type;
    ajax.check(params.type, 'type');
    return ajax.ajax(
      {
        ...opt,
        method: 'GET',
        url,
        ...p
      },
      path,
      this.$basePath
    );
  };
  /**
   * 
   * @summary 获取特定用户--文章
   * @param params ParamsuserArticlePageNewUsingGet
   
   * @param opt ajax config
   * @returns models.CommonResultPageableResultSingleArticleInfo
   */
  public userArticlePageNewUsingGet = (
    params: ParamsuserArticlePageNewUsingGet,
    opt?: ExtraFetchParams
  ): AjaxPromise<models.CommonResultPageableResultSingleArticleInfo> => {
    const path = '/api/user/article/page-new';
    const url = this.$basePath + path;
    const p: any = {};
    p.query = {};
    if ('pageNum' in params) p.query.pageNum = params.pageNum;
    ajax.check(params.pageNum, 'pageNum');
    if ('pageSize' in params) p.query.pageSize = params.pageSize;
    ajax.check(params.pageSize, 'pageSize');
    if ('status' in params) p.query.status = params.status;
    if ('targetUser' in params) p.query.targetUser = params.targetUser;
    ajax.check(params.targetUser, 'targetUser');
    return ajax.ajax(
      {
        ...opt,
        method: 'GET',
        url,
        ...p
      },
      path,
      this.$basePath
    );
  };
  /**
   * 
   * @summary 你的文章--已发布/草稿
   * @param params ParamsuserArticleUsingGet
   
   * @param opt ajax config
   * @returns models.CommonResultPageableResultUserArticleDraftInfo
   */
  public userArticleUsingGet = (
    params: ParamsuserArticleUsingGet,
    opt?: ExtraFetchParams
  ): AjaxPromise<models.CommonResultPageableResultUserArticleDraftInfo> => {
    const path = '/api/user/article';
    const url = this.$basePath + path;
    const p: any = {};
    p.query = {};
    if ('pageNum' in params) p.query.pageNum = params.pageNum;
    ajax.check(params.pageNum, 'pageNum');
    if ('pageSize' in params) p.query.pageSize = params.pageSize;
    ajax.check(params.pageSize, 'pageSize');
    if ('targetUser' in params) p.query.targetUser = params.targetUser;
    ajax.check(params.targetUser, 'targetUser');
    if ('type' in params) p.query.type = params.type;
    ajax.check(params.type, 'type');
    return ajax.ajax(
      {
        ...opt,
        method: 'GET',
        url,
        ...p
      },
      path,
      this.$basePath
    );
  };
  /**
   *
   * @summary 用户收件箱
   * @param params ParamsuserByTypesMessageUsingPost
   * @param data: ParamsBodyuserByTypesMessageUsingPost// 查询类型,数组为空则全部/1赞/2评论/3回复/4@/5邀请/6关注/7回答/8留言/9圈子加入申请
   * @param opt ajax config
   * @returns models.CommonResultPageableResultUserMessageInfo
   */
  public userByTypesMessageUsingPost = (
    params: ParamsuserByTypesMessageUsingPost,
    data: ParamsBodyuserByTypesMessageUsingPost,
    opt?: ExtraFetchParams
  ): AjaxPromise<models.CommonResultPageableResultUserMessageInfo> => {
    const path = '/api/user/by-types/message';
    const url = this.$basePath + path;
    const p: any = {};
    p.query = {};
    if ('pageNum' in params) p.query.pageNum = params.pageNum;
    ajax.check(params.pageNum, 'pageNum');
    if ('pageSize' in params) p.query.pageSize = params.pageSize;
    ajax.check(params.pageSize, 'pageSize');
    p.data = data;
    return ajax.ajax(
      {
        ...opt,
        method: 'POST',
        url,
        ...p
      },
      path,
      this.$basePath
    );
  };
  /**
   * 
   * @summary 取消收藏稍后阅读文章
   * @param params ParamsuserCollectionArticleIdCancelUsingPost
   
   * @param opt ajax config
   * @returns models.CommonResult
   */
  public userCollectionArticleIdCancelUsingPost = (
    params: ParamsuserCollectionArticleIdCancelUsingPost,
    opt?: ExtraFetchParams
  ): AjaxPromise<models.CommonResult> => {
    const path = '/api/user/collection/{articleId}/cancel';
    const url =
      this.$basePath +
      path.replace(/\{([^}]+)\}/g, (all, param) => (param in params ? params[param] : param));
    const p: any = {};
    ajax.check(params.articleId, 'articleId');
    return ajax.ajax(
      {
        ...opt,
        method: 'POST',
        url,
        ...p
      },
      path,
      this.$basePath
    );
  };
  /**
   * 
   * @summary 用户增加稍后阅读文章
   * @param params ParamsuserCollectionArticleIdUsingPost
   
   * @param opt ajax config
   * @returns models.CommonResult
   */
  public userCollectionArticleIdUsingPost = (
    params: ParamsuserCollectionArticleIdUsingPost,
    opt?: ExtraFetchParams
  ): AjaxPromise<models.CommonResult> => {
    const path = '/api/user/collection/{articleId}';
    const url =
      this.$basePath +
      path.replace(/\{([^}]+)\}/g, (all, param) => (param in params ? params[param] : param));
    const p: any = {};
    ajax.check(params.articleId, 'articleId');
    return ajax.ajax(
      {
        ...opt,
        method: 'POST',
        url,
        ...p
      },
      path,
      this.$basePath
    );
  };
  /**
   * 
   * @summary 查看自己收藏的稍后阅读的文章(新分页)
   * @param params ParamsuserCollectionUsingGet
   
   * @param opt ajax config
   * @returns models.CommonResultPageableResultSingleArticleInfo
   */
  public userCollectionUsingGet = (
    params: ParamsuserCollectionUsingGet,
    opt?: ExtraFetchParams
  ): AjaxPromise<models.CommonResultPageableResultSingleArticleInfo> => {
    const path = '/api/user/collection';
    const url = this.$basePath + path;
    const p: any = {};
    p.query = {};
    if ('lastMark' in params) p.query.lastMark = params.lastMark;
    ajax.check(params.lastMark, 'lastMark');
    if ('pageSize' in params) p.query.pageSize = params.pageSize;
    ajax.check(params.pageSize, 'pageSize');
    return ajax.ajax(
      {
        ...opt,
        method: 'GET',
        url,
        ...p
      },
      path,
      this.$basePath
    );
  };
  /**
   * 
   * @summary 用户页面--评论
   * @param params ParamsuserCommentUsingGet
   
   * @param opt ajax config
   * @returns models.CommonResultPageableResultUserCommentInfo
   */
  public userCommentUsingGet = (
    params: ParamsuserCommentUsingGet,
    opt?: ExtraFetchParams
  ): AjaxPromise<models.CommonResultPageableResultUserCommentInfo> => {
    const path = '/api/user/comment';
    const url = this.$basePath + path;
    const p: any = {};
    p.query = {};
    if ('pageNum' in params) p.query.pageNum = params.pageNum;
    ajax.check(params.pageNum, 'pageNum');
    if ('pageSize' in params) p.query.pageSize = params.pageSize;
    ajax.check(params.pageSize, 'pageSize');
    if ('targetUser' in params) p.query.targetUser = params.targetUser;
    ajax.check(params.targetUser, 'targetUser');
    return ajax.ajax(
      {
        ...opt,
        method: 'GET',
        url,
        ...p
      },
      path,
      this.$basePath
    );
  };
  /**
   * 
   * @summary 简单的目标用户信息
   * @param params ParamsuserDetailsUsingGet
   
   * @param opt ajax config
   * @returns models.CommonResultDetailsTargetUserInfo
   */
  public userDetailsUsingGet = (
    params: ParamsuserDetailsUsingGet,
    opt?: ExtraFetchParams
  ): AjaxPromise<models.CommonResultDetailsTargetUserInfo> => {
    const path = '/api/user/details';
    const url = this.$basePath + path;
    const p: any = {};
    p.query = {};
    if ('targetUser' in params) p.query.targetUser = params.targetUser;
    ajax.check(params.targetUser, 'targetUser');
    return ajax.ajax(
      {
        ...opt,
        method: 'GET',
        url,
        ...p
      },
      path,
      this.$basePath
    );
  };
  /**
   * 
   * @summary 用户编辑个人信息
   
   * @param data: ParamsBodyuserEditUsingPost// 用户信息
   * @param opt ajax config
   * @returns models.CommonResult
   */
  public userEditUsingPost = (
    data: ParamsBodyuserEditUsingPost,
    opt?: ExtraFetchParams
  ): AjaxPromise<models.CommonResult> => {
    const path = '/api/user/edit';
    const url = this.$basePath + path;
    const p: any = {};
    p.data = data;
    ajax.check(data, 'body.condition');
    return ajax.ajax(
      {
        ...opt,
        method: 'POST',
        url,
        ...p
      },
      path,
      this.$basePath
    );
  };
  /**
   * 
   * @summary 关注/取关用户
   
   * @param data: ParamsBodyuserFollowUsingPost// 想要关注/取关的用户
   * @param opt ajax config
   * @returns models.CommonResult
   */
  public userFollowUsingPost = (
    data: ParamsBodyuserFollowUsingPost,
    opt?: ExtraFetchParams
  ): AjaxPromise<models.CommonResult> => {
    const path = '/api/user/follow';
    const url = this.$basePath + path;
    const p: any = {};
    p.data = data;
    ajax.check(data, 'body.condition');
    return ajax.ajax(
      {
        ...opt,
        method: 'POST',
        url,
        ...p
      },
      path,
      this.$basePath
    );
  };
  /**
   * 
   * @summary 用户页面展示信息
   * @param params ParamsuserInformationUsingGet
   
   * @param opt ajax config
   * @returns models.CommonResultUserInfo
   */
  public userInformationUsingGet = (
    params: ParamsuserInformationUsingGet,
    opt?: ExtraFetchParams
  ): AjaxPromise<models.CommonResultUserInfo> => {
    const path = '/api/user/information';
    const url = this.$basePath + path;
    const p: any = {};
    p.query = {};
    if ('targetUser' in params) p.query.targetUser = params.targetUser;
    ajax.check(params.targetUser, 'targetUser');
    return ajax.ajax(
      {
        ...opt,
        method: 'GET',
        url,
        ...p
      },
      path,
      this.$basePath
    );
  };
  /**
   * 
   * @summary 当前登录用户的简单的目标用户信息
   
   
   * @param opt ajax config
   * @returns models.CommonResultSimpleUserInfo
   */
  public userLoginSimpleUsingPost = (
    opt?: ExtraFetchParams
  ): AjaxPromise<models.CommonResultSimpleUserInfo> => {
    const path = '/api/user/login/simple';
    const url = this.$basePath + path;
    const p: any = {};
    return ajax.ajax(
      {
        ...opt,
        method: 'POST',
        url,
        ...p
      },
      path,
      this.$basePath
    );
  };
  /**
   * 
   * @summary 根据消息id删除消息
   * @param params ParamsuserMessageIdUsingDelete
   
   * @param opt ajax config
   * @returns models.CommonResult
   */
  public userMessageIdUsingDelete = (
    params: ParamsuserMessageIdUsingDelete,
    opt?: ExtraFetchParams
  ): AjaxPromise<models.CommonResult> => {
    const path = '/api/user/{messageId}';
    const url =
      this.$basePath +
      path.replace(/\{([^}]+)\}/g, (all, param) => (param in params ? params[param] : param));
    const p: any = {};
    ajax.check(params.messageId, 'messageId');
    return ajax.ajax(
      {
        ...opt,
        method: 'DELETE',
        url,
        ...p
      },
      path,
      this.$basePath
    );
  };
  /**
   *
   * @summary 用户收件箱消息数量
   * @param params ParamsuserMessageNumberUsingPost
   * @param data: ParamsBodyuserMessageNumberUsingPost// 查询类型,0全部/1赞/2评论/3回复/4@/5邀请/6关注/7回答/8留言/9圈子加入申请
   * @param opt ajax config
   * @returns models.CommonResultint
   */
  public userMessageNumberUsingPost = (
    params: ParamsuserMessageNumberUsingPost,
    data: ParamsBodyuserMessageNumberUsingPost,
    opt?: ExtraFetchParams
  ): AjaxPromise<models.CommonResultint> => {
    const path = '/api/user/message-number';
    const url = this.$basePath + path;
    const p: any = {};
    p.query = {};
    if ('read' in params) p.query.read = params.read;
    p.data = data;
    ajax.check(data, 'body.type');
    return ajax.ajax(
      {
        ...opt,
        method: 'POST',
        url,
        ...p
      },
      path,
      this.$basePath
    );
  };
  /**
   * 
   * @summary 用户收件箱
   * @param params ParamsuserMessageUsingGet
   
   * @param opt ajax config
   * @returns models.CommonResultPageableResultUserMessageInfo
   */
  public userMessageUsingGet = (
    params: ParamsuserMessageUsingGet,
    opt?: ExtraFetchParams
  ): AjaxPromise<models.CommonResultPageableResultUserMessageInfo> => {
    const path = '/api/user/message';
    const url = this.$basePath + path;
    const p: any = {};
    p.query = {};
    if ('pageNum' in params) p.query.pageNum = params.pageNum;
    ajax.check(params.pageNum, 'pageNum');
    if ('pageSize' in params) p.query.pageSize = params.pageSize;
    ajax.check(params.pageSize, 'pageSize');
    if ('type' in params) p.query.type = params.type;
    ajax.check(params.type, 'type');
    return ajax.ajax(
      {
        ...opt,
        method: 'GET',
        url,
        ...p
      },
      path,
      this.$basePath
    );
  };
  /**
   * 
   * @summary 查看自己收藏的稍后阅读的文章
   * @param params ParamsuserMyCollectionUsingGet
   
   * @param opt ajax config
   * @returns models.CommonResultPageableResultSingleArticleInfo
   */
  public userMyCollectionUsingGet = (
    params: ParamsuserMyCollectionUsingGet,
    opt?: ExtraFetchParams
  ): AjaxPromise<models.CommonResultPageableResultSingleArticleInfo> => {
    const path = '/api/user/myCollection';
    const url = this.$basePath + path;
    const p: any = {};
    p.query = {};
    if ('pageNum' in params) p.query.pageNum = params.pageNum;
    ajax.check(params.pageNum, 'pageNum');
    if ('pageSize' in params) p.query.pageSize = params.pageSize;
    ajax.check(params.pageSize, 'pageSize');
    return ajax.ajax(
      {
        ...opt,
        method: 'GET',
        url,
        ...p
      },
      path,
      this.$basePath
    );
  };
  /**
   * 
   * @summary 查看自己关注的人和关注自己的人
   * @param params ParamsuserMyFollowUsingGet
   
   * @param opt ajax config
   * @returns models.CommonResultPageableResultUserInfo
   */
  public userMyFollowUsingGet = (
    params: ParamsuserMyFollowUsingGet,
    opt?: ExtraFetchParams
  ): AjaxPromise<models.CommonResultPageableResultUserInfo> => {
    const path = '/api/user/myFollow';
    const url = this.$basePath + path;
    const p: any = {};
    p.query = {};
    if ('pageNum' in params) p.query.pageNum = params.pageNum;
    ajax.check(params.pageNum, 'pageNum');
    if ('pageSize' in params) p.query.pageSize = params.pageSize;
    ajax.check(params.pageSize, 'pageSize');
    if ('type' in params) p.query.type = params.type;
    ajax.check(params.type, 'type');
    return ajax.ajax(
      {
        ...opt,
        method: 'GET',
        url,
        ...p
      },
      path,
      this.$basePath
    );
  };
  /**
   * 
   * @summary 催更
   
   * @param data: ParamsBodyuserPressUsingPost// pressVO
   * @param opt ajax config
   * @returns models.CommonResult
   */
  public userPressUsingPost = (
    data: ParamsBodyuserPressUsingPost,
    opt?: ExtraFetchParams
  ): AjaxPromise<models.CommonResult> => {
    const path = '/api/user/press';
    const url = this.$basePath + path;
    const p: any = {};
    p.data = data;
    ajax.check(data, 'body.pressVO');
    return ajax.ajax(
      {
        ...opt,
        method: 'POST',
        url,
        ...p
      },
      path,
      this.$basePath
    );
  };
  /**
   * 
   * @summary 用户页面--提问
   * @param params ParamsuserQuestionUsingGet
   
   * @param opt ajax config
   * @returns models.CommonResultPageableResultQuestionSimpleInfo
   */
  public userQuestionUsingGet = (
    params: ParamsuserQuestionUsingGet,
    opt?: ExtraFetchParams
  ): AjaxPromise<models.CommonResultPageableResultQuestionSimpleInfo> => {
    const path = '/api/user/question';
    const url = this.$basePath + path;
    const p: any = {};
    p.query = {};
    if ('pageNum' in params) p.query.pageNum = params.pageNum;
    ajax.check(params.pageNum, 'pageNum');
    if ('pageSize' in params) p.query.pageSize = params.pageSize;
    ajax.check(params.pageSize, 'pageSize');
    if ('targetUser' in params) p.query.targetUser = params.targetUser;
    ajax.check(params.targetUser, 'targetUser');
    return ajax.ajax(
      {
        ...opt,
        method: 'GET',
        url,
        ...p
      },
      path,
      this.$basePath
    );
  };
  /**
   * 
   * @summary 简单的目标用户信息
   * @param params ParamsuserSimpleUsingGet
   
   * @param opt ajax config
   * @returns models.CommonResultSimpleTargetUserInfo
   */
  public userSimpleUsingGet = (
    params: ParamsuserSimpleUsingGet,
    opt?: ExtraFetchParams
  ): AjaxPromise<models.CommonResultSimpleTargetUserInfo> => {
    const path = '/api/user/simple';
    const url = this.$basePath + path;
    const p: any = {};
    p.query = {};
    if ('targetUser' in params) p.query.targetUser = params.targetUser;
    ajax.check(params.targetUser, 'targetUser');
    return ajax.ajax(
      {
        ...opt,
        method: 'GET',
        url,
        ...p
      },
      path,
      this.$basePath
    );
  };
  /**
   * 
   * @summary 置顶/取消置顶
   * @param params ParamsuserStickyMessageIdUsingPut
   
   * @param opt ajax config
   * @returns models.CommonResult
   */
  public userStickyMessageIdUsingPut = (
    params: ParamsuserStickyMessageIdUsingPut,
    opt?: ExtraFetchParams
  ): AjaxPromise<models.CommonResult> => {
    const path = '/api/user/sticky/{messageId}';
    const url =
      this.$basePath +
      path.replace(/\{([^}]+)\}/g, (all, param) => (param in params ? params[param] : param));
    const p: any = {};
    p.query = {};
    if ('sticky' in params) p.query.sticky = params.sticky;
    ajax.check(params.sticky, 'sticky');
    ajax.check(params.messageId, 'messageId');
    return ajax.ajax(
      {
        ...opt,
        method: 'PUT',
        url,
        ...p
      },
      path,
      this.$basePath
    );
  };
  /**
   * 
   * @summary 用户页面--标注
   * @param params ParamsuserTaggingUsingGet
   
   * @param opt ajax config
   * @returns models.CommonResultPageableResultUserSignInfo
   */
  public userTaggingUsingGet = (
    params: ParamsuserTaggingUsingGet,
    opt?: ExtraFetchParams
  ): AjaxPromise<models.CommonResultPageableResultUserSignInfo> => {
    const path = '/api/user/tagging';
    const url = this.$basePath + path;
    const p: any = {};
    p.query = {};
    if ('pageNum' in params) p.query.pageNum = params.pageNum;
    ajax.check(params.pageNum, 'pageNum');
    if ('pageSize' in params) p.query.pageSize = params.pageSize;
    ajax.check(params.pageSize, 'pageSize');
    if ('targetUser' in params) p.query.targetUser = params.targetUser;
    ajax.check(params.targetUser, 'targetUser');
    return ajax.ajax(
      {
        ...opt,
        method: 'GET',
        url,
        ...p
      },
      path,
      this.$basePath
    );
  };
  /**
   * 
   * @summary 用户页面--赞
   * @param params ParamsuserThumpUpUsingGet
   
   * @param opt ajax config
   * @returns models.CommonResultPageableResultSingleArticleInfo
   */
  public userThumpUpUsingGet = (
    params: ParamsuserThumpUpUsingGet,
    opt?: ExtraFetchParams
  ): AjaxPromise<models.CommonResultPageableResultSingleArticleInfo> => {
    const path = '/api/user/thumpUp';
    const url = this.$basePath + path;
    const p: any = {};
    p.query = {};
    if ('pageNum' in params) p.query.pageNum = params.pageNum;
    ajax.check(params.pageNum, 'pageNum');
    if ('pageSize' in params) p.query.pageSize = params.pageSize;
    ajax.check(params.pageSize, 'pageSize');
    if ('targetUser' in params) p.query.targetUser = params.targetUser;
    ajax.check(params.targetUser, 'targetUser');
    return ajax.ajax(
      {
        ...opt,
        method: 'GET',
        url,
        ...p
      },
      path,
      this.$basePath
    );
  };
  /**
   * 
   * @summary 用户页面--投票
   * @param params ParamsuserVoteUsingGet
   
   * @param opt ajax config
   * @returns models.CommonResultPageableResultVoteQuestionSimplePO
   */
  public userVoteUsingGet = (
    params: ParamsuserVoteUsingGet,
    opt?: ExtraFetchParams
  ): AjaxPromise<models.CommonResultPageableResultVoteQuestionSimplePO> => {
    const path = '/api/user/vote';
    const url = this.$basePath + path;
    const p: any = {};
    p.query = {};
    if ('pageNum' in params) p.query.pageNum = params.pageNum;
    ajax.check(params.pageNum, 'pageNum');
    if ('pageSize' in params) p.query.pageSize = params.pageSize;
    ajax.check(params.pageSize, 'pageSize');
    if ('targetUser' in params) p.query.targetUser = params.targetUser;
    ajax.check(params.targetUser, 'targetUser');
    return ajax.ajax(
      {
        ...opt,
        method: 'GET',
        url,
        ...p
      },
      path,
      this.$basePath
    );
  };
}

export default new UserApi();
